module.exports = __webpack_public_path__ + "static/hecha__final_compressed.ae6a252a.mp4";